import React, { useState ,useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';

import { Link as ScrollLink} from 'react-scroll';
import IconPackage from 'xiv-fanfes-2021';
import styled from '@emotion/styled'
import { DateTime } from 'luxon';
import * as breakpoint from '../../styles/breakpoints.module.scss';


const SectionNavigation = ({ list, hide, submenuOpened }) => {
  
  const [ container, setContainer ] = useState(null);
  const [ mobileActive, setMobileActive ] = useState(false);

  useEffect(() => {
    if(document)
      setContainer(document.querySelector('.tl-wrapper'));
  },[]);

  const renderList = useCallback(() => {
    return list.map((item)=>{
      let classname = '';
      if(item.updateTime)
      {
        let updateTimeObj = DateTime.fromISO(item.updateTime);
        if(updateTimeObj.diff(DateTime.local(), [ 'days']).values.days > -3)
        classname += 'updated'
      }
  
      return(
      <SectionLink key={item.id} activeClass="active" to={item.id} spy={true} smooth={true} offset={-100} duration={500} onClick={() => {
        setMobileActive(false);
      }}>
        <SectionName>{item.name}</SectionName>
        <SectionIcon className={classname}><IconPackage.Icon type={item.icon} /></SectionIcon>
      </SectionLink>
      );
    })
  },[list])


  return (<React.Fragment>
    {container && ReactDOM.createPortal(
      <MobileNavigationWrapper className={`${mobileActive ? "mobileActive" : ""} ${hide ? "hide" : ""} ${submenuOpened ? "submenuOpened" : ""}`} >
        <MobileWrapper >
          <MobileToggle href="#" onClick={(e) => {
              e.preventDefault();
              setMobileActive(!mobileActive)
            }}>
            <span></span>
          </MobileToggle>
          <div>
            {renderList()}
          </div>
        </MobileWrapper>
    </MobileNavigationWrapper>, container)}
  </React.Fragment>)
  
  
}

export default SectionNavigation;

const MobileNavigationWrapper = styled.div`
  position:fixed;
  width:50px;
  background: rgba(44, 44, 46, 0.7);
  border: 1px solid rgba(44, 44, 46, 0);
  right:40px;
  top:50vh;
  transform:translateY(-50%);
  z-index:50;
  border-radius: 32px;
  backdrop-filter: blur(8px);
  overflow:hidden;
  

  &:hover{
    overflow:visible;
  }

  @media only screen and (max-width: ${breakpoint.smMax}){
    right:16px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
    position:fixed;
    transform:none;
    top:32px;
    right:80px;
    width:48px;
    height:48px;
    z-index:101;
    overflow: visible;
    background:none;
    transition: transform .5s;
    backdrop-filter: none;
    
    &.hide{
      transform: translateY(-109px);
    }

    &.submenuOpened{
      z-index:99;
    }
  }
`;

const MobileWrapper = styled.div`
  
  @media only screen and (max-width: ${breakpoint.xsMax}){
    position:absolute;
    top:0;
    left:0;
    width:48px;
    background: rgba(44, 44, 46, 0.25);
    border: 1px solid rgba(44, 44, 46, 0.1);
    border-radius: 32px;
    backdrop-filter: blur(8px);


    >div{
      overflow:hidden;
      max-height:0;
      transition: all .5s;
    }
    .mobileActive & > div{
      max-height:100vh;
    }

  }
`

const MobileToggle = styled.a`
  width:46px;
  height:46px;
  display:none;
  position: relative;
  > span, > span:before, >span:after{
    content:' ';
    display:block;
    width:4px;
    height:4px;
    border-radius: 32px;
    position:absolute;
    left:50%;
    margin-left:-2px;
    background: #F2F2F5;
    top:50%;
  }

  >span{
    margin-top:-2px;
  }
  >span:before{
    margin-top: -10px;
  }
  >span:after{
    margin-top:6px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:block;
  }
`

const SectionLink = styled(ScrollLink)`
  width:32px;
  height:32px;
  display:block;
  margin:8px 8px;
  border-radius:16px;
  text-align:center;
  position:relative;
  cursor: pointer;
  transition: all .3s;

  

  &:hover{
    background: #ECECEF;
  }

  &:active{
    background: #F2F2F5;
  }

  &.active{
    background: #D00F31;
  }
`

const SectionName = styled.span`
  display:block;
  position:absolute;
  letter-spacing: 0.03em;
  font-size: 12px;
  line-height: 16px;
  padding:8px 16px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  white-space:nowrap;
  right:100%;
  margin-right:16px;
  font-weight:bold;
  opacity:0;
  transform:translateX(30px);
  transition: all .3s;

  a:hover &{
    opacity:1;
    transform:translateX(0)
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    display:none;
  }
`

const SectionIcon = styled.span`
  position:absolute;
  top:8px;
  left:8px;
  width:16px;
  height:16px;
  color:#FFFFFF;
  transition: all .3s;
  display:block;
  line-height:32px;

  > svg{
    display:block;
    width:16px;
    height:16px;
  }

  &:before{
    content:' ';
    width:6px;
    height:6px;
    background: #AEEA00;
    border-radius: 3px;
    display:none;
    top:0px;
    right:-6px;
    position:absolute;
  }

  &.updated{
    &:before{
      display:block;
    }
  }

  a:hover &,a:active &{
    color: #000000;
    &:before{
      display:none;
    }
  }

  a.active &{
    color:#FFFFFF;
    &:before{
      display:none;
    }
  }
`
